// const { defaults } = require('lodash');

// window.Vue = require('vue');
import Vue from "vue";
const EventBus = new Vue();
export default EventBus;